export const ItemTypes = {
  File: 'DND.FilePreview',
  Image: 'DND.ImagePreview',
}
